import { createContext } from "react";

export const CurrentArticleContext = createContext();

